export enum EAccess {
  // In use
  ConstantType = 'ConstantType',
  Constant = 'Constant',
  Contact = 'Contact',
  Program = 'Program',
  ProgramStaff = 'ProgramStaff',
  ProgramComment = 'ProgramComment',
  ProgramFile = 'ProgramFile',
  Authentication = 'Authentication',
  User = 'User',
  UserRole = 'UserRole',
  UserForm = 'UserForm',
  Rule = 'Rule',
  RuleParameter = 'RuleParameter',
  Role = 'Role',
  RoleMapping = 'RoleMapping',
  EvideProject = 'EvideProject',
  EvideLicense = 'EvideLicense',
  EvideForm = 'EvideForm',
  FormTemplate = 'FormTemplate',
  ClientForm = 'ClientForm',
  Indicator = 'Indicator',
  Outcome = 'Outcome',
  OutcomeContact = 'OutcomeContact',
  ProgramContact = 'ProgramContact',
  Family = 'Family',
  FamilyAddress = 'FamilyAddress',
  FamilyContact = 'FamilyContact',
  FamilyStaff = 'FamilyStaff',
  NotificationTask = 'NotificationTask',
  NotificationParameterType = 'NotificationParameterType',
  NotificationRule = 'NotificationRule',
  NotificationRuleParameter = 'NotificationRuleParameter',
  NotificationTemplate = 'NotificationTemplate',
  NotificationTemplateParameter = 'NotificationTemplateParameter',
  NotificationEvent = 'NotificationEvent',
  NotificationEventEndpoint = 'NotificationEventEndpoint',
  ErrorQueue = 'ErrorQueue',
  InputContent = 'InputContent',
  EvideInputContentForm = 'EvideInputContentForm',
  BuilderInputContentForm = 'BuilderInputContentForm',
  Registration = 'Registration',
  RegistrationComplete = 'RegistrationComplete',
  Location = 'Location',
  EvideFormType = 'EvideFormType',
  Activity = 'Activity',
  ActivitySession = 'ActivitySession',
  ActivityStaff = 'ActivityStaff',
  ActivityOrganisation = 'ActivityOrganisation',
  ActivityFile = 'ActivityFile',
  ActivityContact = 'ActivityContact',
  ActivityComment = 'ActivityComment',
  ActivityFormTypeRelation = 'ActivityFormTypeRelation',
  EvideFormTypeRelation = 'EvideFormTypeRelation',
  EvideInputContentValidation = 'EvideInputContentValidation',
  MySchedule = 'MySchedule',
  ActivitySessionHistory = 'ActivitySessionHistory',
  EvideLicenseEmailTemplate = 'EvideLicenseEmailTemplate',
  Terminology = 'Terminology',
  TaskReminder = 'TaskReminder',
  SystemLog = 'SystemLog',
  Questionnaire = 'Questionnaire',
  Reports = 'Reports',
  ReportGroups = 'ReportGroups',
  MyDashboard = 'MyDashboard',
  Organisation = 'Organisation',
  OrganisationStaff = 'OrganisationStaff',
  OrganisationContact = 'OrganisationContact',
  AllocatedContact = 'AllocatedContact',
  WaitingList = 'WaitingList',
  ActionPlan = 'ActionPlan',
  NonCaseLoad = 'NonCaseLoad',
  Helpline = 'Helpline',
  ProjectSettings = 'ProjectSettings',
  FormTrigger = 'FormTrigger',
  FormTriggerAlert = 'FormTriggerAlert',
  WorkflowRequest = 'WorkflowRequest',
  SessionShare = 'SessionShare',
  UserNotification = 'UserNotification',
  Property = 'Property',
  Occupancy = 'Occupancy'
}

export interface IAccessMethods {
  controllerName: EAccess;
  permitedMethods: string[];
}

export enum EAccessMethod {
  GetTerminologyLayers = 'GetTerminologyLayers',
  Get = 'Get',
  Post = 'Post',
  Put = 'Put',
  Delete = 'Delete',
  Move = 'Move',

  // ChangeLicense
  TokenInfo = 'TokenInfo',
  CompleteFirstLogin = 'CompleteFirstLogin',
  SendMail = 'SendMail',
  SendResetPasswordEmail = 'SendResetPasswordEmail',
  UpdatePasswordEmail = 'UpdatePasswordEmail',
  UpdateMyPassword = 'UpdateMyPassword',
  ChangeLicense = 'ChangeLicense',
  ChangeProject = 'ChangeProject',

  // Constant Type
  GetConstantTypes = 'GetConstantTypes',
  SaveConstantType = 'SaveConstantType',

  // Constant
  GetConstantInfosByConstantTypeId = 'GetConstantInfosByConstantTypeId',
  GetScheduleColorCodes = 'GetScheduleColorCodes',
  SaveConstant = 'SaveConstant',

  // Contact
  GetContactDetailInfoByGuid = 'GetContactDetailInfoByGuid',
  GetContactGridInfoByProjectId = 'GetContactGridInfoByProjectId',
  SaveContactDetailInfo = 'SaveContactDetailInfo',
  CreateContactDetailInfo = 'CreateContactDetailInfo',
  EditContactDetailInfo = 'EditContactDetailInfo',
  ArchiveContact = 'ArchiveContact',
  UnArchiveContact = 'UnArchiveContact',

  //Program
  GetProgramDetailInfoByGuid = 'GetProgramDetailInfoByGuid',
  GetProgramGridInfoByProjectId = 'GetProgramGridInfoByProjectId',
  SaveProgramDetailInfo = 'SaveProgramDetailInfo',

  //ProgramStaff
  AddProgramStaff = 'AddProgramStaff',
  DeleteProgramStaff = 'DeleteProgramStaff',

  //ProgramComment
  ReplyProgramComment = 'ReplyProgramComment',
  AddProgramComment = 'AddProgramComment',
  DeleteProgramComment = 'DeleteProgramComment',
  DeleteReplyProgramComment = 'DeleteReplyProgramComment',

  //ProgramFile
  DeleteProgramFile = 'DeleteProgramFile',
  SaveProgramFile = 'SaveProgramFile',

  // Rule
  SaveRule = 'SaveRule',
  RuleList = 'RuleList',

  // RuleParameter
  SaveRuleParameter = 'SaveRuleParameter',
  GetRuleParametersByRuleId = 'GetRuleParametersByRuleId',

  // RuleParameter
  SaveRole = 'SaveRole',
  GetRoles = 'GetRoles',

  // RoleMapping
  SaveRoleMapping = 'SaveRoleMapping',
  GetRoleMappingListByRoleId = 'GetRoleMappingListByRoleId',

  // `User`
  GetUserInfoList = 'GetUserInfoList',
  SaveUserImage = 'SaveUserImage',
  DeleteUserImageByUserId = 'DeleteUserImageByUserId',
  SaveUser = 'SaveUser',
  SetUserActive = 'SetUserActive',

  // UserRole
  SaveUserRole = 'SaveUserRole',
  GetCustomUserRoleByUserIdAndRoleId = 'GetCustomUserRoleByUserIdAndRoleId',
  GetRolesUserDontHaveListByUserId = 'GetRolesUserDontHaveListByUserId',
  GetUserRolesListByUserId = 'GetUserRolesListByUserId',
  GetStandartUserRoleById = 'GetStandartUserRoleById',
  DeleteStandartUserRole = 'DeleteStandartUserRole',
  DeleteCustomUserRole = 'DeleteCustomUserRole',

  // UserForm
  GetUserDetailInfoByGuid = 'GetUserDetailInfoByGuid',
  GetMyUserDetailInfo = 'GetMyUserDetailInfo',
  GetUserGridInfoByLicenseId = 'GetRolesUserDontHaveListByUserId',
  GetUsersHeaderByLicenseId = 'GetUsersHeaderByLicenseId',
  SaveUserDetailInfo = 'SaveUserDetailInfo',
  SaveMyUserDetailInfo = 'SaveMyUserDetailInfo',

  // EvideProject
  GetMyProjects = 'GetMyProjects',
  GetProjectsByLicenseId = 'GetProjectsByLicenseId',
  GetProjectShortInfosByUserId = 'GetProjectShortInfosByUserId',
  SaveProject = 'SaveProject',
  GetProjectUsage = 'GetProjectUsage',
  GetAllProjectsUsage = 'GetAllProjectsUsage',
  RecalculateStorage = 'RecalculateStorage',

  // EvideLicense
  GetLicenseInfo = 'GetLicenseInfo',
  GetMyLicenses = 'GetMyLicenses',
  EvideLicense = 'EvideLicense',
  SaveLicense = 'SaveLicense',

  // Location
  GetLocationsByLicenseId = 'GetLocationsByLicenseId',
  SaveLocation = 'SaveLocation',

  // EvideForm
  GetMyEvideForms = 'GetMyEvideForms',
  GetEvideFormsByProjectId = 'GetEvideFormsByProjectId',
  PublishEvideForms = 'PublishEvideForms',
  ArchiveEvideFormById = 'ArchiveEvideFormById',

  // EvideFormTypes
  GetEvideFormTypeForInputContentByLicenseId = 'GetEvideFormTypeForInputContentByLicenseId',
  GetEvideFormTypesGridInfoByLicenseId = 'GetEvideFormTypesGridInfoByLicenseId',
  GetEvideFormTypeForMenuByLicenseId = 'GetEvideFormTypeForMenuByLicenseId',
  SaveEvideFormType = 'SaveEvideFormType',

  // Outcome
  GetMyOutcomes = 'GetMyOutcomes',
  GetOutcomeInfoByAimId = 'GetOutcomeInfoByAimId',
  GetOutcomeFormQuestions = 'GetOutcomeFormQuestions',

  // OutcomeContact
  SendOutcomeEmail = 'SendOutcomeEmail',
  CancelContactOutcome = 'CancelContactOutcome',
  GetOutcomeContacts = 'GetOutcomeContacts',
  GetOutcomeContactAnswer = 'GetOutcomeContactAnswer',
  ReSendEmail = 'ReSendEmail',

  // ProgramContact
  SaveProgramContact = 'SaveProgramContact',
  SaveProgramContactComplete = 'SaveProgramContactComplete',
  GetPotantialContacts = 'GetPotantialContacts',
  GetProgramContactCompleteDetailInfo = 'GetProgramContactCompleteDetailInfo',
  GetProgramContactDetailInfo = 'GetProgramContactDetailInfo',
  GetProgramContacts = 'GetProgramContacts',
  DeleteProgramContact = 'DeleteProgramContact',
  DeleteProgramContactComplete = 'DeleteProgramContactComplete',

  // Indicator
  GetIndicatorForm = 'GetIndicatorForm',

  // Notification
  GetMyNotificationTaskList = 'GetMyNotificationTaskList',
  HasMyNotificationTask = 'HasMyNotificationTask',
  NotificationTaskRead = 'NotificationTaskRead',
  NotificationTaskReadAll = 'NotificationTaskReadAll',
  NotificationTaskClear = 'NotificationTaskClear',
  NotificationTaskClearAll = 'NotificationTaskClearAll',
  NotificationTaskUnRead = 'NotificationTaskUnRead',
  GetMyNotificationTemplateAlertInfo = 'GetMyNotificationTemplateAlertInfo',
  SaveUserNotificationTemplateAlertInfo = 'SaveUserNotificationTemplateAlertInfo',

  // NotificationParameterTypes
  GetNotificationParameterTypes = 'GetNotificationParameterTypes',

  // NotificationRules
  GetAvailableRulesForRequestId = 'GetAvailableRulesForRequestId',

  // NotificationRuleParameters
  GetNotificationRuleParameterList = 'GetNotificationRuleParameterList',

  // NotificationTemplateParameters
  GetNotificationTemplateParameterList = 'GetNotificationTemplateParameterList',

  // NotificationEventEndpoint
  GetNotificationEventEndpoints = 'GetNotificationEventEndpoints',
  GetNotificationEventEndpointDynamicButtons = 'GetNotificationEventEndpointDynamicButtons',
  GetNotificationEventEndpointDynamicLinks = 'GetNotificationEventEndpointDynamicLinks',
  GetNotificationEventEndpointEmail = 'GetNotificationEventEndpointEmail',
  SaveNotificationEventEndpointEmail = 'SaveNotificationEventEndpointEmail',
  SaveNotificationEventEndpointFireBase = 'SaveNotificationEventEndpointFireBase',
  GetNotificationEventEndpointFireBase = 'GetNotificationEventEndpointFireBase',
  SaveNotificationEventEndpointTask = 'SaveNotificationEventEndpointTask',
  GetNotificationEventEndpointTask = 'GetNotificationEventEndpointTask',

  // Errors Queue
  GetEvideFormErrorQueueInfos = 'GetEvideFormErrorQueueInfos',

  // InputContent
  EvideInputContent = 'InputContent',
  GetInputContentList = 'GetInputContentList',
  SaveInputContent = 'SaveInputContent',
  GetInputContentByContentId = 'GetInputContentByContentId',
  ArchiveInputContent = 'ArchiveInputContent',

  // EvideInputContentForm
  GetEvideFormByFormId = 'GetEvideFormByFormId',
  GetMyEvideInputContentForms = 'GetMyEvideInputContentForms',
  GetMyEvideInputContentFormsByFormType = 'GetMyEvideInputContentFormsByFormType',
  GetEvideInputContentFormsByProjectId = 'GetEvideInputContentFormsByProjectId',
  DeleteEvideInputContentFormById = 'DeleteEvideInputContentFormById',
  PublishEvideInputContentForm = 'PublishEvideInputContentForm',
  ArchiveEvideInputContentFormById = 'ArchiveEvideInputContentFormById',

  // BuilderInputContentForm
  SaveEvideInputContentFormBuilder = 'SaveEvideInputContentFormBuilder',
  GetDataValueTypes = 'GetDataValueTypes',
  GetEvideInputContentFormBuilderInfoById = 'GetEvideInputContentFormBuilderInfoById',
  GetInputContentListByFormIdAndEvideFormTypeId = 'GetInputContentListByFormIdAndEvideFormTypeId',
  GetDataValueTypesByInputContentId = 'GetDataValueTypesByInputContentId',

  // Registration
  GetContactRegistrations = 'GetContactRegistrations',
  GetRegistrationDetailInfoByGuid = 'GetRegistrationDetailInfoByGuid',
  GetRegistrationGridInfoByContact = 'GetRegistrationGridInfoByContact',
  GetRegistrationGridInfoByContactWithSearch = 'GetRegistrationGridInfoByContactWithSearch',
  SaveRegistrationDetailInfo = 'SaveRegistrationDetailInfo',

  // RegistrationComplete
  SaveRegistrationCompleteDetailInfo = 'SaveRegistrationCompleteDetailInfo',

  // Activity
  GetActivityDetailInfoByGuid = 'GetActivityDetailInfoByGuid',
  SaveActivityDetailInfo = 'SaveActivityDetailInfo',
  GetActivitiesByProgramGuidForCombo = 'GetActivitiesByProgramGuidForCombo',

  // ActivitySession
  AddContactToActivitySession = 'AddContactToActivitySession',
  GetActivitySessionDetailInfoByGuid = 'GetActivitySessionDetailInfoByGuid',
  GetActivitySessions = 'GetActivitySessions',
  GetActivitySessionsByActivityGuid = 'GetActivitySessionsByActivityGuid',
  GetActivitySessionsByContactGuid = 'GetActivitySessionsByContactGuid',
  GetActivitySessionsByUserGuid = 'GetActivitySessionsByUserGuid',
  SaveActivitySessionDetailInfo = 'SaveActivitySessionDetailInfo',
  CancelActivitySession = 'CancelActivitySession',
  DeleteContactFromActivity = 'DeleteContactFromActivity',
  GetAttendanceFormUrlByActivitySessionGuid = 'GetAttendanceFormUrlByActivitySessionGuid',
  GetActivitySessionsByProgramGuid = 'GetActivitySessionsByProgramGuid',
  GetActivitySessionEmailsByGuid = 'GetActivitySessionEmailsByGuid',
  SendAttendanceFormUrlByEmail = 'SendAttendanceFormUrlByEmail',

  // ActivityStaff
  AddActivityStaff = 'AddActivityStaff',
  DeleteActivityStaff = 'DeleteActivityStaff',
  GetActivityStaffs = 'GetActivityStaffs',
  GetPotantialActivityStaffs = 'GetPotantialActivityStaffs',

  // ActivityOrganisation
  AddActivityOrganisation = 'AddActivityOrganisation',
  DeleteActivityOrganisation = 'DeleteActivityOrganisation',
  GetActivityOrganisations = 'GetActivityOrganisations',

  // ActivityComment
  AddActivityComment = 'AddActivityComment',
  DeleteActivityComment = 'DeleteActivityComment',
  DeleteReplyActivityComment = 'DeleteReplyActivityComment',
  GetActivityComments = 'GetActivityComments',
  ReplyActivityComment = 'ReplyActivityComment',

  // ActivityFile
  SaveActivityFile = 'SaveActivityFile',
  DeleteActivityFile = 'DeleteActivityFile',
  GetActivityFiles = 'GetActivityFiles',

  // ActivityContact
  SaveActivityContact = 'SaveActivityContact',
  SaveActivityContactComplete = 'SaveActivityContactComplete',
  GetActivityPotantialContacts = 'GetActivityPotantialContacts',
  GetActivityContacts = 'GetActivityContacts',
  GetActivityContactDetailInfoByGuid = 'GetActivityContactDetailInfoByGuid',
  GetActivityContactCompleteDetailInfoByGuid = 'GetActivityContactCompleteDetailInfoByGuid',
  DeleteActivityContact = 'DeleteActivityContact',
  DeleteActivityContactComplete = 'DeleteActivityContactComplete',

  // ActivitySessionHistory
  GetActivitySessionHistoriesGridInfoByActivityGuid = 'GetActivitySessionHistoriesGridInfoByActivityGuid',
  GetActivitySessionHistoriesGridInfoByContactGuid = 'GetActivitySessionHistoriesGridInfoByContactGuid',
  GetActivitySessionHistoriesGridInfoByProgramGuid = 'GetActivitySessionHistoriesGridInfoByProgramGuid',
  GetActivitySessionHistorieseGridInfoByUserGuid = 'GetActivitySessionHistorieseGridInfoByUserGuid',
  GetActivitySessionHistoriesGridInfoByContactAndActivityGuid = 'GetActivitySessionHistoriesGridInfoByContactAndActivityGuid',

  // EvideFormTypeRelation
  SaveEvideFormTypeRelation = 'SaveEvideFormTypeRelation',
  GetEvideFormTypeRelationByEvideFormTypeId = 'GetEvideFormTypeRelationByEvideFormTypeId',

  // EvideInputContentValidation
  GetEvideInputContentValidationOperations = 'GetEvideInputContentValidationOperations',
  GetEvideInputContentValidationsByEvideInputContentGuid = 'GetEvideInputContentValidationsByEvideInputContentGuid',
  SaveEvideInputContentValidation = 'SaveEvideInputContentValidation',

  // EvideLicenseEmailTemplate
  GetEvideLicenseEmailTemplateInfosByEvideLicenseId = 'GetEvideLicenseEmailTemplateInfosByEvideLicenseId', // Admin
  SaveEvideLicenseEmailTemplate = 'SaveEvideLicenseEmailTemplate',

  // TaskReminder
  GetTaskReminderDetailInfoByGuid = 'GetTaskReminderDetailInfoByGuid',
  GetTaskReminderGridInfoByContactGuid = 'GetTaskReminderGridInfoByContactGuid',
  GetTaskReminderGridInfoByContactGuidWithSearch = 'GetTaskReminderGridInfoByContactGuidWithSearch',
  GetTaskReminders = 'GetTaskReminders',
  GetTaskRemindersByContactGuid = 'GetTaskRemindersByContactGuid',
  GetTaskRemindersByUserGuid = 'GetTaskRemindersByUserGuid',
  SaveTaskReminder = 'SaveTaskReminder',

  // SystemLog
  GetSystemLogGridInfoByContactGuid = 'GetSystemLogGridInfoByContactGuid',
  GetSystemLogGridInfoByContactGuidWithSearch = 'GetSystemLogGridInfoByContactGuidWithSearch',

  // Questionnaire
  GetQuestionnaireItemDetailInfoByGuid = 'GetQuestionnaireItemDetailInfoByGuid',
  SaveQuestionnaireItemDetailInfo = 'SaveQuestionnaireItemDetailInfo',
  GetPotantialQuestionnaireActivities = 'GetPotantialQuestionnaireActivities',
  GetPotantialQuestionnairePrograms = 'GetPotantialQuestionnairePrograms',
  GetQuestionnaireFormUrl = 'GetQuestionnaireFormUrl',
  GetQuestionnaireNamesContactsByContactGuid = 'GetQuestionnaireNamesContactsByContactGuid',
  GetQuestionnaireActivities = 'GetQuestionnaireActivities',
  GetQuestionnairePrograms = 'GetQuestionnairePrograms',
  AddQuestionnaireActivity = 'AddQuestionnaireActivity',
  AddQuestionnaireProgram = 'AddQuestionnaireProgram',
  AddContactQuestionnaireRelation = 'AddContactQuestionnaireRelation',
  GetActivitiesForQuestionnaireDropdown = 'GetActivitiesForQuestionnaireDropdown',
  GetProgramsForQuestionnaireDropdown = 'GetProgramsForQuestionnaireDropdown',
  GetActivityQuestionnaireList = 'GetActivityQuestionnaireList',
  GetProgramQuestionnaireList = 'GetProgramQuestionnaireList',
  GetDefaultQuestionnaireList = 'GetDefaultQuestionnaireList',
  GetQuestionnaireItemGridInfoByProjectId = 'GetQuestionnaireItemGridInfoByProjectId',
  GetQuestionnaireEmailsByContactGuid = 'GetQuestionnaireEmailsByContactGuid',
  SendQuestionnaireUrlByEmail = 'SendQuestionnaireUrlByEmail',
  GetQuestionnaireHistoriesGridInfo = 'GetQuestionnaireHistoriesGridInfo',
  GetQuestionnaireReportDetailInfoByGuid = 'GetQuestionnaireReportDetailInfoByGuid',
  GetQuestionnaireItemsForDropdown = 'GetQuestionnaireItemsForDropdown',
  ExportCSVQuestionnaireReportDetailInfoByGuid = 'ExportCSVQuestionnaireReportDetailInfoByGuid',
  DeleteContactQuestionnaireRelation = 'DeleteContactQuestionnaireRelation',
  DeleteQuestionnaireActivity = 'DeleteQuestionnaireActivity',
  DeleteQuestionnaireProgram = 'DeleteQuestionnaireProgram',
  DeleteQuestionnaireItem = 'DeleteQuestionnaireItem',

  // Reports
  GetReportGroupsForDropdownByLicenseId = 'GetReportGroupsForDropdownByLicenseId',
  GetEmbededReportInfoByReportId = 'GetEmbededReportInfoByReportId',
  GetPowerBIExportByReportId = 'GetPowerBIExportByReportId',
  GetMyReportsByReportGroup = 'GetMyReportsByReportGroup',
  GetReportsByLicenseId = 'GetReportsByLicenseId',
  GetReportsByProjectId = 'GetReportsByProjectId',
  ReOrderReports = 'ReOrderReports',
  SaveReport = 'SaveReport',
  DeleteReportById = 'DeleteReportById',
  GetReportTilesByReportId = 'GetReportTilesByReportId',
  SaveReportTilesByReportId = 'SaveReportTilesByReportId',

  // ReportGroups
  GetMyReportGroups = 'GetMyReportGroups',
  GetReportGroups = 'GetReportGroups',
  GetReportGroupById = 'GetReportGroupById',
  SaveReportGroup = 'SaveReportGroup',
  DeleteReportGroupById = 'DeleteReportGroupById',
  ReOrderReportGroups = 'ReOrderReportGroups',

  // MyDashboard
  AddToMyDashboardReport = 'AddToMyDashboardReport',
  GetMyDashboard = 'GetMyDashboard',
  ReOrderMyDashboard = 'ReOrderMyDashboard',
  ResizeMyDashboardReport = 'ResizeMyDashboardReport',
  RemoveFromMyDashboardReport = 'RemoveFromMyDashboardReport',

  // Organisations
  GetOrganisationDetailInfoByGuid = 'GetOrganisationDetailInfoByGuid',
  GetOrganisationGridInfoByProjectId = 'GetOrganisationGridInfoByProjectId',
  GetOrganisationsHeaderByProjectId = 'GetOrganisationsHeaderByProjectId',
  SaveOrganisationDetailInfo = 'SaveOrganisationDetailInfo',

  // OrganisationStaff
  AddOrganisationStaff = 'AddOrganisationStaff',
  DeleteOrganisationStaff = 'DeleteOrganisationStaff',
  GetOrganisationPotantialStaffs = 'GetOrganisationPotantialStaffs',
  GetOrganisationStaffs = 'GetOrganisationStaffs',

  // OrganisationContact
  AddOrganisationContact = 'AddOrganisationContact',
  AddOrganisationContacts = 'AddOrganisationContacts',
  DeleteOrganisationContact = 'DeleteOrganisationContact',
  GetOrganisationPotantialContacts = 'GetOrganisationPotantialContacts',
  GetOrganisationContact = 'GetOrganisationContact',
  GetOrganisationContacts = 'GetOrganisationContacts',
  GetOrganisationsByContactGuid = 'GetOrganisationsByContactGuid',
  GetOrganisationContactPotantialOrganisations = 'GetOrganisationContactPotantialOrganisations',

  // AllocatedContact
  GetAllocatedContactDetailInfoByGuid = 'GetAllocatedContactDetailInfoByGuid',
  GetAllocatedContactGridInfoByContactGuid = 'GetAllocatedContactGridInfoByContactGuid',
  GetAllocatedContactsByContactGuid = 'GetAllocatedContactsByContactGuid',
  SaveAllocatedContactDetailInfo = 'SaveAllocatedContactDetailInfo',
  GetPotantialAllocatedUsersByContactGuid = 'GetPotantialAllocatedUsersByContactGuid',
  AllocatedContactDelete = 'AllocatedContact.Delete',

  // Family
  DeleteFamily = 'DeleteFamily',
  GetFamilyDetailInfoByGuid = 'GetFamilyDetailInfoByGuid',
  GetFamilyGridInfoByProjectId = 'GetFamilyGridInfoByProjectId',
  GetFamiliesHeaderByProjectId = 'GetFamiliesHeaderByProjectId',
  SaveFamilyDetailInfo = 'SaveFamilyDetailInfo',

  // FamilyAddress
  AddFamilyAddress = 'AddFamilyAddress',
  SetPrimaryFamilyAddress = 'SetPrimaryFamilyAddress',
  CloseFamilyAddress = 'CloseFamilyAddress',
  RemoveFamilyAddress = 'RemoveFamilyAddress',

  // FamilyContact
  AddFamilyMember = 'AddFamilyMember',
  GetAddFamilyMemberDetailInfo = 'GetAddFamilyMemberDetailInfo',
  DeleteFamilyContact = 'DeleteFamilyContact',
  GetFamilyPotentialContacts = 'GetFamilyPotentialContacts',
  GetFamilyContacts = 'GetFamilyContacts',
  GetFamiliesByContactGuid = 'GetFamiliesByContactGuid',
  GetFamilyContactPotentialFamilies = 'GetFamilyContactPotentialFamilies',

  // FamilyStaff
  AddFamilyStaff = 'AddFamilyStaff',
  DeleteFamilyStaff = 'DeleteFamilyStaff',
  GetFamilyPotentialStaffs = 'GetFamilyPotentialStaffs',
  GetFamilyStaffs = 'GetFamilyStaffs',

  // ProgramEvent
  GetProgramEventDetailInfoByGuid = 'GetProgramEventDetailInfoByGuid',
  GetProgramEventGridInfo = 'GetProgramEventGridInfo',
  GetProgramEventsByProgramGuid = 'GetProgramEventsByProgramGuid',
  GetProgramEvents = 'GetProgramEvents',
  SaveProgramEventDetailInfo = 'SaveProgramEventDetailInfo',
  CompleteProgramEvent = 'CompleteProgramEvent',
  CancelProgramEvent = 'CancelProgramEvent',
  DeleteProgramEvent = 'DeleteProgramEvent',

  // WaitingList
  GetWaitingListEntries = 'GetWaitingListEntries',
  GetWaitingListByContactGuid = 'GetWaitingListByContactGuid',
  GetWaitingListByProgramGuid = 'GetWaitingListByProgramGuid',
  GetWaitingListByActivityGuid = 'GetWaitingListByActivityGuid',
  GetWaitingListDetailInfoByGuid = 'GetWaitingListDetailInfoByGuid',
  SaveWaitingListEntry = 'SaveWaitingListEntry',
  UpdateWaitingListStatus = 'UpdateWaitingListStatus',
  DeleteWaitingListEntry = 'DeleteWaitingListEntry',
  GetWaitingListSummary = 'GetWaitingListSummary',

  // ActionPlan
  GetActionPlanEntries = 'GetActionPlanEntries',
  GetActionPlansByContactGuid = 'GetActionPlansByContactGuid',
  GetActionPlanDetailInfoByGuid = 'GetActionPlanDetailInfoByGuid',
  GetActionPlanSummary = 'GetActionPlanSummary',
  SaveActionPlan = 'SaveActionPlan',
  UpdateActionPlanStatus = 'UpdateActionPlanStatus',
  DeleteActionPlan = 'DeleteActionPlan',
  HardDeleteActionPlan = 'HardDeleteActionPlan',

  // NonCaseLoad
  GetNonCaseLoadEntries = 'GetNonCaseLoadEntries',
  GetNonCaseLoadEntryByGuid = 'GetNonCaseLoadEntryByGuid',
  GetNonCaseLoadDetailInfoByGuid = 'GetNonCaseLoadDetailInfoByGuid',
  SaveNonCaseLoadEntry = 'SaveNonCaseLoadEntry',
  DeleteNonCaseLoadEntry = 'DeleteNonCaseLoadEntry',
  GetNonCaseLoadSummary = 'GetNonCaseLoadSummary',

  // Helpline
  GetHelplineEntries = 'GetHelplineEntries',
  GetHelplineEntryByGuid = 'GetHelplineEntryByGuid',
  GetHelplineDetailInfoByGuid = 'GetHelplineDetailInfoByGuid',
  SaveHelplineEntry = 'SaveHelplineEntry',
  DeleteHelplineEntry = 'DeleteHelplineEntry',
  GetHelplineSummary = 'GetHelplineSummary',

  // Property (Properties/Units/Accommodation)
  GetProperties = 'GetProperties',
  GetProperty = 'GetProperty',
  SaveProperty = 'SaveProperty',
  ArchiveProperty = 'ArchiveProperty',
  UnArchiveProperty = 'UnArchiveProperty',
  SaveUnit = 'SaveUnit',
  BulkCreateUnits = 'BulkCreateUnits',
  ArchiveUnit = 'ArchiveUnit',
  UnArchiveUnit = 'UnArchiveUnit',
  SetUnitUnavailable = 'SetUnitUnavailable',
  EndUnitUnavailability = 'EndUnitUnavailability',

  // Occupancy (tenant allocation)
  Allocate = 'Allocate',
  EndOccupancy = 'EndOccupancy',
  Transfer = 'Transfer',
  GetCurrentTenants = 'GetCurrentTenants',
  GetContactAccommodation = 'GetContactAccommodation',
  GetUnitOccupancyHistory = 'GetUnitOccupancyHistory',
  GetAllocationOptions = 'GetAllocationOptions',
  ProgramHasAllocatableUnits = 'ProgramHasAllocatableUnits',

  // ProjectSettings
  GetProjectSettings = 'GetProjectSettings',
  SaveProjectSettings = 'SaveProjectSettings',

  // FormTrigger (Risk Alert configuration - sys admin)
  GetTriggers = 'GetTriggers',
  SaveTrigger = 'SaveTrigger',
  DeleteTrigger = 'DeleteTrigger',
  GetMonitorableFields = 'GetMonitorableFields',

  // FormTriggerAlert (High-Risk Alerts)
  GetAlerts = 'GetAlerts',
  ResolveAlert = 'ResolveAlert',
  GetOpenAlertCount = 'GetOpenAlertCount',

  // UserNotification (the bell / notification history)
  GetMyNotifications = 'GetMyNotifications',
  GetMyUnseenCount = 'GetMyUnseenCount',
  MarkAllSeen = 'MarkAllSeen',

  // WorkflowRequest (approvals — session extension requests)
  SubmitSessionExtensionRequest = 'SubmitSessionExtensionRequest',
  GetRequests = 'GetRequests',
  DecideRequest = 'DecideRequest',
  GetPendingApprovalCount = 'GetPendingApprovalCount',

  // SessionShare
  GetGrantsForScope = 'GetGrantsForScope',
  CreateGrant = 'CreateGrant',
  RevokeGrant = 'RevokeGrant',
  UpdateExclusions = 'UpdateExclusions',
  SetVisibilityModel = 'SetVisibilityModel',
  GetAudit = 'GetAudit'
}

export const AccesssMethods: { [key in EAccess]?: any } = {
  [EAccess.Authentication]: {
    [EAccessMethod.TokenInfo]: 'Authentication.TokenInfo',
    [EAccessMethod.CompleteFirstLogin]: 'Authentication.CompleteFirstLogin',
    [EAccessMethod.SendMail]: 'Authentication.SendMail',
    [EAccessMethod.SendResetPasswordEmail]:
      'Authentication.SendResetPasswordEmail',
    [EAccessMethod.UpdatePasswordEmail]: 'Authentication.UpdatePasswordEmail',
    [EAccessMethod.UpdateMyPassword]: 'Authentication.UpdateMyPassword',
    [EAccessMethod.ChangeLicense]: 'Authentication.ChangeLicense',
    [EAccessMethod.ChangeProject]: 'Authentication.ChangeProject'
  },
  [EAccess.ConstantType]: {
    [EAccessMethod.GetConstantTypes]: 'ConstantType.GetConstantTypes',
    [EAccessMethod.SaveConstantType]: 'ConstantType.SaveConstantType',
    [EAccessMethod.Delete]: 'ConstantType.Delete'
  },
  [EAccess.Constant]: {
    [EAccessMethod.GetConstantInfosByConstantTypeId]:
      'Constant.GetConstantInfosByConstantTypeId',
    [EAccessMethod.GetScheduleColorCodes]: 'Constant.GetScheduleColorCodes',
    [EAccessMethod.SaveConstant]: 'Constant.SaveConstant',
    [EAccessMethod.Delete]: 'Constant.Delete'
  },
  [EAccess.Contact]: {
    [EAccessMethod.GetContactDetailInfoByGuid]:
      'Contact.GetContactDetailInfoByGuid',
    [EAccessMethod.GetContactGridInfoByProjectId]:
      'Contact.GetContactGridInfoByProjectId',
    [EAccessMethod.SaveContactDetailInfo]: 'Contact.SaveContactDetailInfo',
    [EAccessMethod.CreateContactDetailInfo]: 'Contact.CreateContactDetailInfo',
    [EAccessMethod.EditContactDetailInfo]: 'Contact.EditContactDetailInfo',
    [EAccessMethod.ArchiveContact]: 'Contact.ArchiveContact',
    [EAccessMethod.UnArchiveContact]: 'Contact.UnArchiveContact',
    [EAccessMethod.Delete]: 'Contact.Delete'
  },
  [EAccess.Program]: {
    [EAccessMethod.GetProgramDetailInfoByGuid]:
      'Program.GetProgramDetailInfoByGuid',
    [EAccessMethod.GetProgramGridInfoByProjectId]:
      'Program.GetProgramGridInfoByProjectId',
    [EAccessMethod.SaveProgramDetailInfo]: 'Program.SaveProgramDetailInfo',
    [EAccessMethod.Delete]: 'Program.Delete',
     [EAccessMethod.GetProgramEventDetailInfoByGuid]: 'ProgramEvent.GetProgramEventDetailInfoByGuid',
    [EAccessMethod.GetProgramEventGridInfo]: 'ProgramEvent.GetProgramEventGridInfo',
    [EAccessMethod.GetProgramEventsByProgramGuid]: 'ProgramEvent.GetProgramEventsByProgramGuid',
    [EAccessMethod.GetProgramEvents]: 'ProgramEvent.GetProgramEvents',
    [EAccessMethod.SaveProgramEventDetailInfo]: 'ProgramEvent.SaveProgramEventDetailInfo',
    [EAccessMethod.CompleteProgramEvent]: 'ProgramEvent.CompleteProgramEvent',
    [EAccessMethod.CancelProgramEvent]: 'ProgramEvent.CancelProgramEvent',
    [EAccessMethod.DeleteProgramEvent]: 'ProgramEvent.DeleteProgramEvent',
  },
  [EAccess.ProgramStaff]: {
    [EAccessMethod.AddProgramStaff]: 'ProgramStaff.AddProgramStaff',
    [EAccessMethod.DeleteProgramStaff]: 'ProgramStaff.DeleteProgramStaff'
  },
  [EAccess.ProgramComment]: {
    [EAccessMethod.ReplyProgramComment]: 'ProgramComment.ReplyProgramComment',
    [EAccessMethod.AddProgramComment]: 'ProgramComment.AddProgramComment',
    [EAccessMethod.DeleteProgramComment]: 'ProgramComment.DeleteProgramComment',
    [EAccessMethod.DeleteReplyProgramComment]:
      'ProgramComment.DeleteReplyProgramComment'
  },
  [EAccess.ProgramFile]: {
    [EAccessMethod.DeleteProgramFile]: 'ProgramFile.DeleteProgramFile',
    [EAccessMethod.SaveProgramFile]: 'ProgramFile.SaveProgramFile'
  },
  [EAccess.Rule]: {
    [EAccessMethod.RuleList]: 'Rule.RuleList',
    [EAccessMethod.SaveRule]: 'Rule.SaveRule',
    [EAccessMethod.Delete]: 'Rule.Delete'
  },
  [EAccess.RuleParameter]: {
    [EAccessMethod.GetRuleParametersByRuleId]:
      'RuleParameter.GetRuleParametersByRuleId',
    [EAccessMethod.SaveRuleParameter]: 'RuleParameter.SaveRuleParameter',
    [EAccessMethod.Delete]: 'RuleParameter.Delete'
  },
  [EAccess.Role]: {
    [EAccessMethod.GetRoles]: 'Role.GetRoles',
    [EAccessMethod.SaveRole]: 'Role.SaveRole',
    [EAccessMethod.Delete]: 'Role.Delete'
  },
  [EAccess.RoleMapping]: {
    [EAccessMethod.GetRoleMappingListByRoleId]:
      'RoleMapping.GetRoleMappingListByRoleId',
    [EAccessMethod.SaveRoleMapping]: 'RoleMapping.SaveRoleMapping',
    [EAccessMethod.Delete]: 'RoleMapping.Delete'
  },
  [EAccess.User]: {
    [EAccessMethod.GetUserInfoList]: 'User.GetUserInfoList',
    [EAccessMethod.SaveUserImage]: 'User.SaveUserImage',
    [EAccessMethod.DeleteUserImageByUserId]: 'User.DeleteUserImageByUserId',
    [EAccessMethod.SaveUser]: 'User.SaveUser',
    [EAccessMethod.SetUserActive]: 'User.SetUserActive',
    [EAccessMethod.Delete]: 'User.Delete'
  },
  [EAccess.UserRole]: {
    [EAccessMethod.SaveUserRole]: 'UserRole.SaveUserRole',
    [EAccessMethod.GetCustomUserRoleByUserIdAndRoleId]:
      'UserRole.GetCustomUserRoleByUserIdAndRoleId',
    [EAccessMethod.GetRolesUserDontHaveListByUserId]:
      'UserRole.GetRolesUserDontHaveListByUserId',
    [EAccessMethod.GetUserRolesListByUserId]:
      'UserRole.GetUserRolesListByUserId',
    [EAccessMethod.GetStandartUserRoleById]: 'UserRole.GetStandartUserRoleById',
    [EAccessMethod.DeleteStandartUserRole]: 'UserRole.DeleteStandartUserRole',
    [EAccessMethod.DeleteCustomUserRole]: 'UserRole.DeleteCustomUserRole'
  },
  [EAccess.UserForm]: {
    [EAccessMethod.GetUserDetailInfoByGuid]: 'UserForm.GetUserDetailInfoByGuid',
    [EAccessMethod.GetMyUserDetailInfo]: 'UserForm.GetMyUserDetailInfo',
    [EAccessMethod.GetUserGridInfoByLicenseId]:
      'UserForm.GetUserGridInfoByLicenseId',
    [EAccessMethod.GetUsersHeaderByLicenseId]:
      'UserForm.GetUsersHeaderByLicenseId',
    [EAccessMethod.SaveUserDetailInfo]: 'UserForm.SaveUserDetailInfo',
    [EAccessMethod.SaveMyUserDetailInfo]: 'UserForm.SaveMyUserDetailInfo'
  },

  [EAccess.EvideProject]: {
    [EAccessMethod.GetMyProjects]: 'EvideProject.GetMyProjects',
    [EAccessMethod.GetProjectsByLicenseId]:
      'EvideProject.GetProjectsByLicenseId',
    [EAccessMethod.GetProjectShortInfosByUserId]:
      'EvideProject.GetProjectShortInfosByUserId',
    [EAccessMethod.SaveProject]: 'EvideProject.SaveProject',
    [EAccessMethod.GetProjectUsage]: 'EvideProject.GetProjectUsage',
    [EAccessMethod.GetAllProjectsUsage]: 'EvideProject.GetAllProjectsUsage',
    [EAccessMethod.RecalculateStorage]: 'EvideProject.RecalculateStorage',
    [EAccessMethod.Delete]: 'EvideProject.Delete'
  },
  [EAccess.EvideLicense]: {
    [EAccessMethod.GetLicenseInfo]: 'EvideLicense.GetLicenseInfo',
    [EAccessMethod.GetMyLicenses]: 'EvideLicense.GetMyLicenses',
    [EAccessMethod.EvideLicense]: 'EvideLicense.EvideLicense',
    [EAccessMethod.SaveLicense]: 'EvideLicense.SaveLicense',
    [EAccessMethod.Delete]: 'EvideLicense.Delete'
  },
  [EAccess.Location]: {
    [EAccessMethod.Delete]: 'Location.Delete',
    [EAccessMethod.Get]: 'Location.Get',
    [EAccessMethod.GetLocationsByLicenseId]: 'Location.GetLocationsByLicenseId',
    [EAccessMethod.SaveLocation]: 'Location.SaveLocation'
  },
  [EAccess.EvideFormType]: {
    [EAccessMethod.Get]: 'EvideFormType.Get',
    [EAccessMethod.GetEvideFormTypeForInputContentByLicenseId]:
      'EvideFormType.GetEvideFormTypeForInputContentByLicenseId',
    [EAccessMethod.GetEvideFormTypesGridInfoByLicenseId]:
      'EvideFormType.GetEvideFormTypesGridInfoByLicenseId',
    [EAccessMethod.GetEvideFormTypeForMenuByLicenseId]:
      'EvideFormType.GetEvideFormTypeForMenuByLicenseId',
    [EAccessMethod.SaveEvideFormType]: 'EvideFormType.SaveEvideFormType',
    [EAccessMethod.Delete]: 'EvideFormType.Delete'
  },
  [EAccess.Outcome]: {
    [EAccessMethod.GetMyOutcomes]: 'Outcome.GetMyOutcomes',
    [EAccessMethod.GetOutcomeInfoByAimId]: 'Outcome.GetOutcomeInfoByAimId',
    [EAccessMethod.GetOutcomeFormQuestions]: 'Outcome.GetOutcomeFormQuestions'
  },
  [EAccess.OutcomeContact]: {
    [EAccessMethod.SendOutcomeEmail]: 'OutcomeContact.SendOutcomeEmail',
    [EAccessMethod.CancelContactOutcome]: 'OutcomeContact.CancelContactOutcome',
    [EAccessMethod.GetOutcomeContacts]: 'OutcomeContact.GetOutcomeContacts',
    [EAccessMethod.GetOutcomeContactAnswer]:
      'OutcomeContact.GetOutcomeContactAnswer',
    [EAccessMethod.ReSendEmail]: 'OutcomeContact.ReSendEmail'
  },
  [EAccess.ProgramContact]: {
    [EAccessMethod.SaveProgramContact]: 'ProgramContact.SaveProgramContact',
    [EAccessMethod.SaveProgramContactComplete]:
      'ProgramContact.SaveProgramContactComplete',
    [EAccessMethod.GetPotantialContacts]: 'ProgramContact.GetPotantialContacts',
    [EAccessMethod.GetProgramContactCompleteDetailInfo]:
      'ProgramContact.GetProgramContactCompleteDetailInfo',
    [EAccessMethod.GetProgramContactDetailInfo]:
      'ProgramContact.GetProgramContactDetailInfo',
    [EAccessMethod.GetProgramContacts]: 'ProgramContact.GetProgramContacts',
    [EAccessMethod.DeleteProgramContact]: 'ProgramContact.DeleteProgramContact',
    [EAccessMethod.DeleteProgramContactComplete]:
      'ProgramContact.DeleteProgramContactComplete'
  },
  [EAccess.Indicator]: {
    [EAccessMethod.GetIndicatorForm]: 'Indicator.GetIndicatorForm'
  },
  [EAccess.NotificationTask]: {
    [EAccessMethod.GetMyNotificationTaskList]:
      'NotificationTask.GetMyNotificationTaskList',
    [EAccessMethod.HasMyNotificationTask]:
      'NotificationTask.HasMyNotificationTask',
    [EAccessMethod.NotificationTaskRead]:
      'NotificationTask.NotificationTaskRead',
    [EAccessMethod.NotificationTaskReadAll]:
      'NotificationTask.NotificationTaskReadAll',
    [EAccessMethod.NotificationTaskClear]:
      'NotificationTask.NotificationTaskClear',
    [EAccessMethod.NotificationTaskClearAll]:
      'NotificationTask.NotificationTaskClearAll',
    [EAccessMethod.NotificationTaskUnRead]:
      'NotificationTask.NotificationTaskUnRead',
    [EAccessMethod.GetMyNotificationTemplateAlertInfo]:
      'NotificationTask.GetMyNotificationTemplateAlertInfo',
    [EAccessMethod.SaveUserNotificationTemplateAlertInfo]:
      'NotificationTask.SaveUserNotificationTemplateAlertInfo'
  },
  [EAccess.NotificationParameterType]: {
    [EAccessMethod.Get]: 'NotificationParameterType.Get',
    [EAccessMethod.GetNotificationParameterTypes]:
      'NotificationParameterType.GetNotificationParameterTypes',
    [EAccessMethod.Post]: 'NotificationParameterType.Post',
    [EAccessMethod.Put]: 'NotificationParameterType.Put',
    [EAccessMethod.Delete]: 'NotificationParameterType.Delete'
  },
  [EAccess.NotificationRule]: {
    [EAccessMethod.Get]: 'NotificationRule.Get',
    [EAccessMethod.GetAvailableRulesForRequestId]:
      'NotificationRule.GetAvailableRulesForRequestId',
    [EAccessMethod.Post]: 'NotificationRule.Post',
    [EAccessMethod.Put]: 'NotificationRule.Put',
    [EAccessMethod.Delete]: 'NotificationRule.Delete'
  },
  [EAccess.NotificationRuleParameter]: {
    [EAccessMethod.Get]: 'NotificationRuleParameter.Get',
    [EAccessMethod.GetNotificationRuleParameterList]:
      'NotificationRuleParameter.GetNotificationRuleParameterList',
    [EAccessMethod.Post]: 'NotificationRuleParameter.Post',
    [EAccessMethod.Put]: 'NotificationRuleParameter.Put',
    [EAccessMethod.Delete]: 'NotificationRuleParameter.Delete'
  },
  [EAccess.NotificationTemplate]: {
    [EAccessMethod.Get]: 'NotificationTemplate.Get',
    [EAccessMethod.Post]: 'NotificationTemplate.Post',
    [EAccessMethod.Put]: 'NotificationTemplate.Put',
    [EAccessMethod.Delete]: 'NotificationTemplate.Delete'
  },
  [EAccess.NotificationTemplateParameter]: {
    [EAccessMethod.Get]: 'NotificationTemplateParameter.Get',
    [EAccessMethod.GetNotificationTemplateParameterList]:
      'NotificationTemplateParameter.GetNotificationTemplateParameterList',
    [EAccessMethod.Post]: 'NotificationTemplateParameter.Post',
    [EAccessMethod.Put]: 'NotificationTemplateParameter.Put',
    [EAccessMethod.Delete]: 'NotificationTemplateParameter.Delete'
  },
  [EAccess.NotificationEvent]: {
    [EAccessMethod.Get]: 'NotificationEvent.Get',
    [EAccessMethod.Post]: 'NotificationEvent.Post',
    [EAccessMethod.Put]: 'NotificationEvent.Put',
    [EAccessMethod.Delete]: 'NotificationEvent.Delete'
  },
  [EAccess.NotificationEventEndpoint]: {
    [EAccessMethod.Get]: 'NotificationEventEndpoint.Get',
    [EAccessMethod.Post]: 'NotificationEventEndpoint.Post',
    [EAccessMethod.Put]: 'NotificationEventEndpoint.Put',
    [EAccessMethod.Delete]: 'NotificationEventEndpoint.Delete',
    [EAccessMethod.GetNotificationEventEndpoints]:
      'NotificationEventEndpoint.GetNotificationEventEndpoints',
    [EAccessMethod.GetNotificationEventEndpointDynamicButtons]:
      'NotificationEventEndpoint.GetNotificationEventEndpointDynamicButtons',
    [EAccessMethod.GetNotificationEventEndpointDynamicLinks]:
      'NotificationEventEndpoint.GetNotificationEventEndpointDynamicLinks',
    [EAccessMethod.GetNotificationEventEndpointEmail]:
      'NotificationEventEndpoint.GetNotificationEventEndpointEmail',
    [EAccessMethod.SaveNotificationEventEndpointEmail]:
      'NotificationEventEndpoint.SaveNotificationEventEndpointEmail',
    [EAccessMethod.SaveNotificationEventEndpointFireBase]:
      'NotificationEventEndpoint.SaveNotificationEventEndpointFireBase',
    [EAccessMethod.GetNotificationEventEndpointFireBase]:
      'NotificationEventEndpoint.GetNotificationEventEndpointFireBase',
    [EAccessMethod.SaveNotificationEventEndpointTask]:
      'NotificationEventEndpoint.SaveNotificationEventEndpointTask',
    [EAccessMethod.GetNotificationEventEndpointTask]:
      'NotificationEventEndpoint.GetNotificationEventEndpointTask'
  },
  [EAccess.ErrorQueue]: {
    [EAccessMethod.GetEvideFormErrorQueueInfos]:
      'ErrorQueue.GetEvideFormErrorQueueInfos'
  },
  [EAccess.InputContent]: {
    [EAccessMethod.GetInputContentList]: 'InputContent.GetInputContentList',
    [EAccessMethod.SaveInputContent]: 'InputContent.SaveInputContent',
    [EAccessMethod.GetInputContentByContentId]:
      'InputContent.GetInputContentByContentId',
    [EAccessMethod.Delete]: 'InputContent.Delete',
    [EAccessMethod.ArchiveInputContent]: 'InputContent.ArchiveInputContent'
  },
  [EAccess.EvideInputContentForm]: {
    [EAccessMethod.GetEvideFormByFormId]:
      'EvideInputContentForm.GetEvideFormByFormId',
    [EAccessMethod.GetMyEvideInputContentForms]:
      'EvideInputContentForm.GetMyEvideInputContentForms',
    [EAccessMethod.GetMyEvideInputContentFormsByFormType]:
      'EvideInputContentForm.GetMyEvideInputContentFormsByFormType',
    [EAccessMethod.GetEvideInputContentFormsByProjectId]:
      'EvideInputContentForm.GetEvideInputContentFormsByProjectId',
    [EAccessMethod.DeleteEvideInputContentFormById]:
      'EvideInputContentForm.DeleteEvideInputContentFormById',
    [EAccessMethod.PublishEvideInputContentForm]:
      'EvideInputContentForm.PublishEvideInputContentForm',
    [EAccessMethod.ArchiveEvideInputContentFormById]:
      'EvideInputContentForm.ArchiveEvideInputContentFormById'
  },

  [EAccess.BuilderInputContentForm]: {
    [EAccessMethod.GetDataValueTypes]:
      'BuilderInputContentForm.GetDataValueTypes',
    [EAccessMethod.GetEvideInputContentFormBuilderInfoById]:
      'BuilderInputContentForm.GetEvideInputContentFormBuilderInfoById',
    [EAccessMethod.GetDataValueTypesByInputContentId]:
      'BuilderInputContentForm.GetDataValueTypesByInputContentId',
    [EAccessMethod.GetInputContentListByFormIdAndEvideFormTypeId]:
      'BuilderInputContentForm.GetInputContentListByFormIdAndEvideFormTypeId',
    [EAccessMethod.SaveEvideInputContentFormBuilder]:
      'BuilderInputContentForm.SaveEvideInputContentFormBuilder'
  },
  [EAccess.Registration]: {
    [EAccessMethod.Delete]: 'Registration.Delete',
    [EAccessMethod.GetContactRegistrations]:
      'Registration.GetContactRegistrations',
    [EAccessMethod.GetRegistrationDetailInfoByGuid]:
      'Registration.GetRegistrationDetailInfoByGuid',
    [EAccessMethod.GetRegistrationGridInfoByContact]:
      'Registration.GetRegistrationGridInfoByContact',
    [EAccessMethod.GetRegistrationGridInfoByContactWithSearch]:
      'Registration.GetRegistrationGridInfoByContactWithSearch',
    [EAccessMethod.SaveRegistrationDetailInfo]:
      'Registration.SaveRegistrationDetailInfo'
  },
  [EAccess.RegistrationComplete]: {
    [EAccessMethod.Delete]: 'RegistrationComplete.Delete',
    [EAccessMethod.SaveRegistrationCompleteDetailInfo]:
      'RegistrationComplete.SaveRegistrationCompleteDetailInfo'
  },
  [EAccess.Activity]: {
    [EAccessMethod.SaveActivityDetailInfo]: 'Activity.SaveActivityDetailInfo',
    [EAccessMethod.GetActivityDetailInfoByGuid]:
      'Activity.GetActivityDetailInfoByGuid',
    [EAccessMethod.Delete]: 'Activity.Delete'
  },
  [EAccess.ActivitySession]: {
    [EAccessMethod.AddContactToActivitySession]:
      'ActivitySession.AddContactToActivitySession',
    [EAccessMethod.GetActivitySessionDetailInfoByGuid]:
      'ActivitySession.GetActivitySessionDetailInfoByGuid',
    [EAccessMethod.GetActivitySessions]: 'ActivitySession.GetActivitySessions',
    [EAccessMethod.GetActivitySessionsByActivityGuid]:
      'ActivitySession.GetActivitySessionsByActivityGuid',
    [EAccessMethod.GetActivitySessionsByContactGuid]:
      'ActivitySession.GetActivitySessionsByContactGuid',
    [EAccessMethod.GetActivitySessionsByUserGuid]:
      'ActivitySession.GetActivitySessionsByUserGuid',
    [EAccessMethod.SaveActivitySessionDetailInfo]:
      'ActivitySession.SaveActivitySessionDetailInfo',
    [EAccessMethod.CancelActivitySession]:
      'ActivitySession.CancelActivitySession',
    [EAccessMethod.DeleteContactFromActivity]:
      'ActivitySession.DeleteContactFromActivity',
    [EAccessMethod.GetAttendanceFormUrlByActivitySessionGuid]:
      'ActivitySession.GetAttendanceFormUrlByActivitySessionGuid',
    [EAccessMethod.Delete]: 'ActivitySession.Delete'
  },
  [EAccess.ActivityComment]: {
    [EAccessMethod.AddActivityComment]: 'ActivityComment.AddActivityComment',
    [EAccessMethod.DeleteActivityComment]:
      'ActivityComment.DeleteActivityComment',
    [EAccessMethod.DeleteReplyActivityComment]:
      'ActivityComment.DeleteReplyActivityComment',
    [EAccessMethod.GetActivityComments]: 'ActivityComment.GetActivityComments',
    [EAccessMethod.ReplyActivityComment]: 'ActivityComment.ReplyActivityComment'
  },
  [EAccess.ActivityContact]: {
    [EAccessMethod.SaveActivityContact]: 'ActivityContact.SaveActivityContact',
    [EAccessMethod.SaveActivityContactComplete]:
      'ActivityContact.SaveActivityContactComplete',
    [EAccessMethod.GetActivityPotantialContacts]:
      'ActivityContact.GetActivityPotantialContacts',
    [EAccessMethod.GetActivityContacts]: 'ActivityContact.GetActivityContacts',
    [EAccessMethod.GetActivityContactDetailInfoByGuid]:
      'ActivityContact.GetActivityContactDetailInfoByGuid',
    [EAccessMethod.GetActivityContactCompleteDetailInfoByGuid]:
      'ActivityContact.GetActivityContactCompleteDetailInfoByGuid',
    [EAccessMethod.DeleteActivityContact]:
      'ActivityContact.DeleteActivityContact',
    [EAccessMethod.DeleteActivityContactComplete]:
      'ActivityContact.DeleteActivityContactComplete'
  },
  [EAccess.ActivityStaff]: {
    [EAccessMethod.AddActivityStaff]: 'ActivityStaff.AddActivityStaff',
    [EAccessMethod.DeleteActivityStaff]: 'ActivityStaff.DeleteActivityStaff',
    [EAccessMethod.GetActivityStaffs]: 'ActivityStaff.GetActivityStaffs',
    [EAccessMethod.GetPotantialActivityStaffs]:
      'ActivityStaff.GetPotantialActivityStaffs'
  },
  [EAccess.ActivityOrganisation]: {
    [EAccessMethod.AddActivityOrganisation]: 'ActivityOrganisation.AddActivityOrganisation',
    [EAccessMethod.DeleteActivityOrganisation]: 'ActivityOrganisation.DeleteActivityOrganisation',
    [EAccessMethod.GetActivityOrganisations]: 'ActivityOrganisation.GetActivityOrganisations'
  },
  [EAccess.ActivityFile]: {
    [EAccessMethod.SaveActivityFile]: 'ActivityFile.SaveActivityFile',
    [EAccessMethod.DeleteActivityFile]: 'ActivityFile.DeleteActivityFile',
    [EAccessMethod.GetActivityFiles]: 'ActivityFile.GetActivityFiles'
  },
  [EAccess.EvideFormTypeRelation]: {
    [EAccessMethod.Delete]: 'EvideFormTypeRelation.Delete',
    [EAccessMethod.Get]: 'EvideFormTypeRelation.Get',
    [EAccessMethod.SaveEvideFormTypeRelation]:
      'EvideFormTypeRelation.SaveEvideFormTypeRelation',
    [EAccessMethod.GetEvideFormTypeRelationByEvideFormTypeId]:
      'EvideFormTypeRelation.GetEvideFormTypeRelationByEvideFormTypeId'
  },
  [EAccess.EvideInputContentValidation]: {
    [EAccessMethod.Delete]: 'EvideInputContentValidation.Delete',
    [EAccessMethod.Get]: 'EvideInputContentValidation.Get',
    [EAccessMethod.GetEvideInputContentValidationOperations]:
      'EvideInputContentValidation.GetEvideInputContentValidationOperations',
    [EAccessMethod.GetEvideInputContentValidationsByEvideInputContentGuid]:
      'EvideInputContentValidation.GetEvideInputContentValidationsByEvideInputContentGuid',
    [EAccessMethod.SaveEvideInputContentValidation]:
      'EvideInputContentValidation.SaveEvideInputContentValidation'
  },
  [EAccess.MySchedule]: {
    [EAccessMethod.Get]: 'MySchedule.Get'
  },
  [EAccess.ActivitySessionHistory]: {
    [EAccessMethod.GetActivitySessionHistoriesGridInfoByActivityGuid]:
      'ActivitySessionHistory.GetActivitySessionHistoriesGridInfoByActivityGuid',
    [EAccessMethod.GetActivitySessionHistoriesGridInfoByContactGuid]:
      'ActivitySessionHistory.GetActivitySessionHistoriesGridInfoByContactGuid',
    [EAccessMethod.GetActivitySessionHistoriesGridInfoByProgramGuid]:
      'ActivitySessionHistory.GetActivitySessionHistoriesGridInfoByProgramGuid',
    [EAccessMethod.GetActivitySessionHistorieseGridInfoByUserGuid]:
      'ActivitySessionHistory.GetActivitySessionHistorieseGridInfoByUserGuid',
    [EAccessMethod.GetActivitySessionHistoriesGridInfoByContactAndActivityGuid]:
      'ActivitySessionHistory.GetActivitySessionHistoriesGridInfoByContactAndActivityGuid'
  },
  [EAccess.EvideLicenseEmailTemplate]: {
    [EAccessMethod.Get]: 'EvideLicenseEmailTemplate.Get',
    [EAccessMethod.Delete]: 'EvideLicenseEmailTemplate.Delete',
    [EAccessMethod.GetEvideLicenseEmailTemplateInfosByEvideLicenseId]:
      'EvideLicenseEmailTemplate.GetEvideLicenseEmailTemplateInfosByEvideLicenseId',
    [EAccessMethod.SaveEvideLicenseEmailTemplate]:
      'EvideLicenseEmailTemplate.SaveEvideLicenseEmailTemplate'
  },
  [EAccess.TaskReminder]: {
    [EAccessMethod.GetTaskReminderDetailInfoByGuid]:
      'TaskReminder.GetTaskReminderDetailInfoByGuid',
    [EAccessMethod.GetTaskReminderGridInfoByContactGuid]:
      'TaskReminder.GetTaskReminderGridInfoByContactGuid',
    [EAccessMethod.GetTaskReminderGridInfoByContactGuidWithSearch]:
      'TaskReminder.GetTaskReminderGridInfoByContactGuidWithSearch',
    [EAccessMethod.SaveTaskReminder]: 'TaskReminder.SaveTaskReminder',
    [EAccessMethod.GetTaskReminders]: 'TaskReminder.GetTaskReminders',
    [EAccessMethod.GetTaskRemindersByContactGuid]:
      'TaskReminder.GetTaskRemindersByContactGuid',
    [EAccessMethod.GetTaskRemindersByUserGuid]:
      'TaskReminder.GetTaskRemindersByUserGuid',
    [EAccessMethod.Delete]: 'TaskReminder.Delete'
  },
  [EAccess.SystemLog]: {
    [EAccessMethod.GetSystemLogGridInfoByContactGuid]:
      'SystemLog.GetSystemLogGridInfoByContactGuid',
    [EAccessMethod.GetSystemLogGridInfoByContactGuidWithSearch]:
      'SystemLog.GetSystemLogGridInfoByContactGuidWithSearch'
  },
  [EAccess.Questionnaire]: {
    [EAccessMethod.GetQuestionnaireItemDetailInfoByGuid]:
      'Questionnaire.GetQuestionnaireItemDetailInfoByGuid',
    [EAccessMethod.SaveQuestionnaireItemDetailInfo]:
      'Questionnaire.SaveQuestionnaireItemDetailInfo',
    [EAccessMethod.GetPotantialQuestionnaireActivities]:
      'Questionnaire.GetPotantialQuestionnaireActivities',
    [EAccessMethod.GetPotantialQuestionnairePrograms]:
      'Questionnaire.GetPotantialQuestionnairePrograms',
    [EAccessMethod.GetQuestionnaireFormUrl]:
      'Questionnaire.GetQuestionnaireFormUrl',
    [EAccessMethod.GetQuestionnaireNamesContactsByContactGuid]:
      'Questionnaire.GetQuestionnaireNamesContactsByContactGuid',
    [EAccessMethod.GetQuestionnaireActivities]:
      'Questionnaire.GetQuestionnaireActivities',
    [EAccessMethod.GetQuestionnairePrograms]:
      'Questionnaire.GetQuestionnairePrograms',
    [EAccessMethod.AddQuestionnaireActivity]:
      'Questionnaire.AddQuestionnaireActivity',
    [EAccessMethod.AddQuestionnaireProgram]:
      'Questionnaire.AddQuestionnaireProgram',
    [EAccessMethod.AddContactQuestionnaireRelation]:
      'Questionnaire.AddContactQuestionnaireRelation',
    [EAccessMethod.GetActivitiesForQuestionnaireDropdown]:
      'Questionnaire.GetActivitiesForQuestionnaireDropdown',
    [EAccessMethod.GetProgramsForQuestionnaireDropdown]:
      'Questionnaire.GetProgramsForQuestionnaireDropdown',
    [EAccessMethod.GetActivityQuestionnaireList]:
      'Questionnaire.GetActivityQuestionnaireList',
    [EAccessMethod.GetProgramQuestionnaireList]:
      'Questionnaire.GetProgramQuestionnaireList',
    [EAccessMethod.GetDefaultQuestionnaireList]:
      'Questionnaire.GetDefaultQuestionnaireList',
    [EAccessMethod.GetQuestionnaireItemGridInfoByProjectId]:
      'Questionnaire.GetQuestionnaireItemGridInfoByProjectId',
    [EAccessMethod.GetQuestionnaireEmailsByContactGuid]:
      'Questionnaire.GetQuestionnaireEmailsByContactGuid',
    [EAccessMethod.SendQuestionnaireUrlByEmail]:
      'Questionnaire.SendQuestionnaireUrlByEmail',
    [EAccessMethod.GetQuestionnaireHistoriesGridInfo]:
      'Questionnaire.GetQuestionnaireHistoriesGridInfo',
    [EAccessMethod.GetQuestionnaireReportDetailInfoByGuid]:
      'Questionnaire.GetQuestionnaireReportDetailInfoByGuid',
    [EAccessMethod.GetQuestionnaireItemsForDropdown]:
      'Questionnaire.GetQuestionnaireItemsForDropdown',
    [EAccessMethod.ExportCSVQuestionnaireReportDetailInfoByGuid]:
      'Questionnaire.ExportCSVQuestionnaireReportDetailInfoByGuid',
    [EAccessMethod.DeleteContactQuestionnaireRelation]:
      'Questionnaire.DeleteContactQuestionnaireRelation',
    [EAccessMethod.DeleteQuestionnaireActivity]:
      'Questionnaire.DeleteQuestionnaireActivity',
    [EAccessMethod.DeleteQuestionnaireProgram]:
      'Questionnaire.DeleteQuestionnaireProgram',
    [EAccessMethod.DeleteQuestionnaireItem]:
      'Questionnaire.DeleteQuestionnaireItem'
  },
  [EAccess.Reports]: {
    [EAccessMethod.GetReportGroupsForDropdownByLicenseId]:
      'Reports.GetReportGroupsForDropdownByLicenseId',
    [EAccessMethod.GetEmbededReportInfoByReportId]:
      'Reports.GetEmbededReportInfoByReportId',
    [EAccessMethod.GetPowerBIExportByReportId]:
      'Reports.GetPowerBIExportByReportId',
    [EAccessMethod.GetMyReportsByReportGroup]:
      'Reports.GetMyReportsByReportGroup',
    [EAccessMethod.GetReportsByLicenseId]: 'Reports.GetReportsByLicenseId',
    [EAccessMethod.GetReportsByProjectId]: 'Reports.GetReportsByProjectId',
    [EAccessMethod.ReOrderReports]: 'Reports.ReOrderReports',
    [EAccessMethod.SaveReport]: 'Reports.SaveReport',
    [EAccessMethod.DeleteReportById]: 'Reports.DeleteReportById',
    [EAccessMethod.GetReportTilesByReportId]:
      'Reports.GetReportTilesByReportId',
    [EAccessMethod.SaveReportTilesByReportId]:
      'Reports.SaveReportTilesByReportId'
  },
  [EAccess.ReportGroups]: {
    [EAccessMethod.GetReportGroups]: 'ReportGroups.GetReportGroups',
    [EAccessMethod.GetMyReportGroups]: 'ReportGroups.GetMyReportGroups',
    [EAccessMethod.GetReportGroupById]: 'ReportGroups.GetReportGroupById',
    [EAccessMethod.SaveReportGroup]: 'ReportGroups.SaveReportGroup',
    [EAccessMethod.DeleteReportGroupById]: 'ReportGroups.DeleteReportGroupById',
    [EAccessMethod.ReOrderReportGroups]: 'ReportGroups.ReOrderReportGroups'
  },
  [EAccess.MyDashboard]: {
    [EAccessMethod.AddToMyDashboardReport]:
      'MyDashboard.AddToMyDashboardReport',
    [EAccessMethod.GetMyDashboard]: 'MyDashboard.GetMyDashboard',
    [EAccessMethod.ReOrderMyDashboard]: 'MyDashboard.ReOrderMyDashboard',
    [EAccessMethod.ResizeMyDashboardReport]:
      'MyDashboard.ResizeMyDashboardReport',
    [EAccessMethod.RemoveFromMyDashboardReport]:
      'MyDashboard.RemoveFromMyDashboardReport'
  },
  [EAccess.Organisation]: {
    [EAccessMethod.Delete]: 'Organisation.Delete',
    [EAccessMethod.GetOrganisationDetailInfoByGuid]:
      'Organisation.GetOrganisationDetailInfoByGuid',
    [EAccessMethod.GetOrganisationGridInfoByProjectId]:
      'Organisation.GetOrganisationGridInfoByProjectId',
    [EAccessMethod.GetOrganisationsHeaderByProjectId]:
      'Organisation.GetOrganisationsHeaderByProjectId',
    [EAccessMethod.SaveOrganisationDetailInfo]:
      'Organisation.SaveOrganisationDetailInfo'
  },
  [EAccess.OrganisationStaff]: {
    [EAccessMethod.AddOrganisationStaff]:
      'OrganisationStaff.AddOrganisationStaff',
    [EAccessMethod.DeleteOrganisationStaff]:
      'OrganisationStaff.DeleteOrganisationStaff',
    [EAccessMethod.GetOrganisationPotantialStaffs]:
      'OrganisationStaff.GetOrganisationPotantialStaffs',
    [EAccessMethod.GetOrganisationStaffs]:
      'OrganisationStaff.GetOrganisationStaffs'
  },
  [EAccess.OrganisationContact]: {
    [EAccessMethod.AddOrganisationContact]:
      'OrganisationContact.AddOrganisationContact',
    [EAccessMethod.AddOrganisationContacts]:
      'OrganisationContact.AddOrganisationContacts',
    [EAccessMethod.DeleteOrganisationContact]:
      'OrganisationContact.DeleteOrganisationContact',
    [EAccessMethod.GetOrganisationPotantialContacts]:
      'OrganisationContact.GetOrganisationPotantialContacts',
    [EAccessMethod.GetOrganisationContacts]:
      'OrganisationContact.GetOrganisationContacts',
    [EAccessMethod.GetOrganisationsByContactGuid]:
      'OrganisationContact.GetOrganisationsByContactGuid',
    [EAccessMethod.GetOrganisationContactPotantialOrganisations]:
      'OrganisationContact.GetOrganisationContactPotantialOrganisations'
  },
  [EAccess.AllocatedContact]: {
    [EAccessMethod.GetAllocatedContactDetailInfoByGuid]:
      'AllocatedContact.GetAllocatedContactDetailInfoByGuid',
    [EAccessMethod.GetAllocatedContactGridInfoByContactGuid]:
      'AllocatedContact.GetAllocatedContactGridInfoByContactGuid',
    [EAccessMethod.GetAllocatedContactsByContactGuid]:
      'AllocatedContact.GetAllocatedContactsByContactGuid',
    [EAccessMethod.SaveAllocatedContactDetailInfo]:
      'AllocatedContact.SaveAllocatedContactDetailInfo',
    [EAccessMethod.GetPotantialAllocatedUsersByContactGuid]:
      'AllocatedContact.GetPotantialAllocatedUsersByContactGuid',
    [EAccessMethod.AllocatedContactDelete]: 'AllocatedContact.Delete'
  },
  [EAccess.Family]: {
    [EAccessMethod.DeleteFamily]: 'Family.Delete',
    [EAccessMethod.GetFamilyDetailInfoByGuid]:
      'Family.GetFamilyDetailInfoByGuid',
    [EAccessMethod.GetFamilyGridInfoByProjectId]:
      'Family.GetFamilyGridInfoByProjectId',
    [EAccessMethod.GetFamiliesHeaderByProjectId]:
      'Family.GetFamiliesHeaderByProjectId',
    [EAccessMethod.SaveFamilyDetailInfo]: 'Family.SaveFamilyDetailInfo',
    [EAccessMethod.AddFamilyAddress]: 'Family.AddFamilyAddress',
    [EAccessMethod.SetPrimaryFamilyAddress]: 'Family.SetPrimaryFamilyAddress',
    [EAccessMethod.CloseFamilyAddress]: 'Family.CloseFamilyAddress',
    [EAccessMethod.RemoveFamilyAddress]: 'Family.RemoveFamilyAddress',

  },
  [EAccess.FamilyStaff]: {
    [EAccessMethod.AddFamilyStaff]: 'FamilyStaff.AddFamilyStaff',
    [EAccessMethod.DeleteFamilyStaff]: 'FamilyStaff.DeleteFamilyStaff',
    [EAccessMethod.GetFamilyPotentialStaffs]: 'FamilyStaff.GetFamilyPotentialStaffs',
    [EAccessMethod.GetFamilyStaffs]: 'FamilyStaff.GetFamilyStaffs'
  },
  [EAccess.FamilyContact]: {
    [EAccessMethod.AddFamilyMember]: 'FamilyContact.AddFamilyMember',
    [EAccessMethod.GetAddFamilyMemberDetailInfo]:
      'FamilyContact.GetAddFamilyMemberDetailInfo',
    [EAccessMethod.DeleteFamilyContact]: 'FamilyContact.DeleteFamilyContact',
    [EAccessMethod.GetFamilyPotentialContacts]:
      'FamilyContact.GetFamilyPotentialContacts',
    [EAccessMethod.GetFamilyContacts]: 'FamilyContact.GetFamilyContacts',
    [EAccessMethod.GetFamiliesByContactGuid]: 'FamilyContact.GetFamiliesByContactGuid',
    [EAccessMethod.GetFamilyContactPotentialFamilies]:
      'FamilyContact.GetFamilyContactPotentialFamilies',
  },
  [EAccess.WaitingList]: {
    [EAccessMethod.GetWaitingListEntries]: 'WaitingList.GetWaitingListEntries',
    [EAccessMethod.GetWaitingListByContactGuid]: 'WaitingList.GetWaitingListByContactGuid',
    [EAccessMethod.GetWaitingListByProgramGuid]: 'WaitingList.GetWaitingListByProgramGuid',
    [EAccessMethod.GetWaitingListByActivityGuid]: 'WaitingList.GetWaitingListByActivityGuid',
    [EAccessMethod.GetWaitingListDetailInfoByGuid]: 'WaitingList.GetWaitingListDetailInfoByGuid',
    [EAccessMethod.SaveWaitingListEntry]: 'WaitingList.SaveWaitingListEntry',
    [EAccessMethod.UpdateWaitingListStatus]: 'WaitingList.UpdateWaitingListStatus',
    [EAccessMethod.DeleteWaitingListEntry]: 'WaitingList.DeleteWaitingListEntry',
    [EAccessMethod.GetWaitingListSummary]: 'WaitingList.GetWaitingListSummary',
  },
  [EAccess.ActionPlan]: {
    [EAccessMethod.GetActionPlanEntries]: 'ActionPlan.GetActionPlanEntries',
    [EAccessMethod.GetActionPlansByContactGuid]: 'ActionPlan.GetActionPlansByContactGuid',
    [EAccessMethod.GetActionPlanDetailInfoByGuid]: 'ActionPlan.GetActionPlanDetailInfoByGuid',
    [EAccessMethod.GetActionPlanSummary]: 'ActionPlan.GetActionPlanSummary',
    [EAccessMethod.SaveActionPlan]: 'ActionPlan.SaveActionPlan',
    [EAccessMethod.UpdateActionPlanStatus]: 'ActionPlan.UpdateActionPlanStatus',
    [EAccessMethod.DeleteActionPlan]: 'ActionPlan.DeleteActionPlan',
    [EAccessMethod.HardDeleteActionPlan]: 'ActionPlan.HardDeleteActionPlan',
  },
  [EAccess.NonCaseLoad]: {
    [EAccessMethod.GetNonCaseLoadEntries]: 'NonCaseLoad.GetNonCaseLoadEntries',
    [EAccessMethod.GetNonCaseLoadEntryByGuid]: 'NonCaseLoad.GetNonCaseLoadEntryByGuid',
    [EAccessMethod.GetNonCaseLoadDetailInfoByGuid]: 'NonCaseLoad.GetNonCaseLoadDetailInfoByGuid',
    [EAccessMethod.SaveNonCaseLoadEntry]: 'NonCaseLoad.SaveNonCaseLoadEntry',
    [EAccessMethod.DeleteNonCaseLoadEntry]: 'NonCaseLoad.DeleteNonCaseLoadEntry',
    [EAccessMethod.GetNonCaseLoadSummary]: 'NonCaseLoad.GetNonCaseLoadSummary',
  },
  [EAccess.Helpline]: {
    [EAccessMethod.GetHelplineEntries]: 'Helpline.GetHelplineEntries',
    [EAccessMethod.GetHelplineEntryByGuid]: 'Helpline.GetHelplineEntryByGuid',
    [EAccessMethod.GetHelplineDetailInfoByGuid]: 'Helpline.GetHelplineDetailInfoByGuid',
    [EAccessMethod.SaveHelplineEntry]: 'Helpline.SaveHelplineEntry',
    [EAccessMethod.DeleteHelplineEntry]: 'Helpline.DeleteHelplineEntry',
    [EAccessMethod.GetHelplineSummary]: 'Helpline.GetHelplineSummary',
  },
  [EAccess.Property]: {
    [EAccessMethod.GetProperties]: 'Property.GetProperties',
    [EAccessMethod.GetProperty]: 'Property.GetProperty',
    [EAccessMethod.SaveProperty]: 'Property.SaveProperty',
    [EAccessMethod.ArchiveProperty]: 'Property.ArchiveProperty',
    [EAccessMethod.UnArchiveProperty]: 'Property.UnArchiveProperty',
    [EAccessMethod.SaveUnit]: 'Property.SaveUnit',
    [EAccessMethod.BulkCreateUnits]: 'Property.BulkCreateUnits',
    [EAccessMethod.ArchiveUnit]: 'Property.ArchiveUnit',
    [EAccessMethod.UnArchiveUnit]: 'Property.UnArchiveUnit',
    [EAccessMethod.SetUnitUnavailable]: 'Property.SetUnitUnavailable',
    [EAccessMethod.EndUnitUnavailability]: 'Property.EndUnitUnavailability',
  },
  [EAccess.Occupancy]: {
    [EAccessMethod.Allocate]: 'Occupancy.Allocate',
    [EAccessMethod.EndOccupancy]: 'Occupancy.EndOccupancy',
    [EAccessMethod.Transfer]: 'Occupancy.Transfer',
    [EAccessMethod.GetCurrentTenants]: 'Occupancy.GetCurrentTenants',
    [EAccessMethod.GetContactAccommodation]: 'Occupancy.GetContactAccommodation',
    [EAccessMethod.GetUnitOccupancyHistory]: 'Occupancy.GetUnitOccupancyHistory',
    [EAccessMethod.GetAllocationOptions]: 'Occupancy.GetAllocationOptions',
    [EAccessMethod.ProgramHasAllocatableUnits]: 'Occupancy.ProgramHasAllocatableUnits',
  },
  [EAccess.SessionShare]: {
    [EAccessMethod.GetGrantsForScope]: 'SessionShare.GetGrantsForScope',
    [EAccessMethod.CreateGrant]: 'SessionShare.CreateGrant',
    [EAccessMethod.RevokeGrant]: 'SessionShare.RevokeGrant',
    [EAccessMethod.UpdateExclusions]: 'SessionShare.UpdateExclusions',
    [EAccessMethod.SetVisibilityModel]: 'SessionShare.SetVisibilityModel',
    [EAccessMethod.GetAudit]: 'SessionShare.GetAudit'
  },
  [EAccess.ProjectSettings]: {
    [EAccessMethod.GetProjectSettings]: 'ProjectSettings.GetProjectSettings',
    [EAccessMethod.SaveProjectSettings]: 'ProjectSettings.SaveProjectSettings',
  },
  [EAccess.FormTrigger]: {
    [EAccessMethod.GetTriggers]: 'FormTrigger.GetTriggers',
    [EAccessMethod.SaveTrigger]: 'FormTrigger.SaveTrigger',
    [EAccessMethod.DeleteTrigger]: 'FormTrigger.DeleteTrigger',
    [EAccessMethod.GetMonitorableFields]: 'FormTrigger.GetMonitorableFields',
  },
  [EAccess.FormTriggerAlert]: {
    [EAccessMethod.GetAlerts]: 'FormTriggerAlert.GetAlerts',
    [EAccessMethod.ResolveAlert]: 'FormTriggerAlert.ResolveAlert',
    [EAccessMethod.GetOpenAlertCount]: 'FormTriggerAlert.GetOpenAlertCount',
  },
  [EAccess.WorkflowRequest]: {
    [EAccessMethod.SubmitSessionExtensionRequest]: 'WorkflowRequest.SubmitSessionExtensionRequest',
    [EAccessMethod.GetRequests]: 'WorkflowRequest.GetRequests',
    [EAccessMethod.DecideRequest]: 'WorkflowRequest.DecideRequest',
    [EAccessMethod.GetPendingApprovalCount]: 'WorkflowRequest.GetPendingApprovalCount',
  },
  [EAccess.UserNotification]: {
    [EAccessMethod.GetMyNotifications]: 'UserNotification.GetMyNotifications',
    [EAccessMethod.GetMyUnseenCount]: 'UserNotification.GetMyUnseenCount',
    [EAccessMethod.MarkAllSeen]: 'UserNotification.MarkAllSeen',
  },
  [EAccess.Terminology]: {
    [EAccessMethod.GetTerminologyLayers]: 'Terminology.GetTerminologyLayers',
  }
};
